import React from "react";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import OPDReports from "./opdReportsTable";


const OPDReportsContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <OPDReports />
      </div>
    </div>
  )
}

export default OPDReportsContainer;
